import { render, staticRenderFns } from "./InformacoesPCM.vue?vue&type=template&id=3801699d&scoped=true"
import script from "./InformacoesPCM.vue?vue&type=script&lang=ts"
export * from "./InformacoesPCM.vue?vue&type=script&lang=ts"
import style0 from "./InformacoesPCM.vue?vue&type=style&index=0&id=3801699d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3801699d",
  null
  
)

export default component.exports